module.exports = __webpack_public_path__ + "img/3.9d44ce6b.png";